export class RequestModel {
  FromDate: Date;
  ToDate: Date;
  Status: string;
  CompanyRFC: string;
  ItemsNo: number;
  Page: number;
}



// WEBPACK FOOTER //
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/models/request.model.ts